export default __webpack_public_path__ + "static/media/DailyRoutine_03.9145963c.png";